import { Box, Typography } from '@mui/material';
import { Headphones } from '@mui/icons-material';
import { useEffect, useState } from 'react';

export default function EpisodeThumbnail({
  imageUrl,
  alt = '',
  episodeNumber = '',
  size = 60,
  loading = 'lazy'
}) {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [imageUrl]);

  const handleImageError = () => {
    setImageError(true);
  };

  const iconSize = typeof size === 'number' ? size * 0.5 : 40;
  const wrapperSx = {
    width: size,
    height: size,
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0
  };
  const artworkOverlay = episodeNumber ? (
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'flex-end',
        p: { xs: 1, sm: 1.5 },
        pointerEvents: 'none',
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 48%, rgba(0, 0, 0, 0.72) 100%)'
      }}
    >
      <Typography
        component="span"
        sx={{
          color: 'common.white',
          fontSize: { xs: '0.65rem', sm: '0.72rem' },
          fontWeight: 700,
          letterSpacing: '0.14em',
          lineHeight: 1,
          textTransform: 'uppercase',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)'
        }}
      >
        Episode {episodeNumber}
      </Typography>
    </Box>
  ) : null;

  if (!imageUrl || imageError) {
    return (
      <Box
        sx={{
          ...wrapperSx,
          bgcolor: 'primary.light',
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'primary.contrastText',
        }}
      >
        <Headphones sx={{ fontSize: iconSize, opacity: 0.8 }} />
        {artworkOverlay}
      </Box>
    );
  }

  return (
    <Box sx={wrapperSx}>
      <Box
        component="img"
        src={imageUrl}
        alt={alt}
        onError={handleImageError}
        loading={loading}
        decoding="async"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          transition: 'transform 0.35s ease',
          '.MuiCard-root:hover &': {
            transform: 'scale(1.03)'
          }
        }}
      />
      {artworkOverlay}
    </Box>
  );
}
